import { render, staticRenderFns } from "./Landing2ApproachDesktop.vue?vue&type=template&id=08b754e8&scoped=true"
import script from "./Landing2ApproachDesktop.vue?vue&type=script&lang=js"
export * from "./Landing2ApproachDesktop.vue?vue&type=script&lang=js"
import style0 from "./Landing2ApproachDesktop.vue?vue&type=style&index=0&id=08b754e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b754e8",
  null
  
)

export default component.exports